import React, { useState, useId, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import { notificationStatuses } from '../../../../utils/constants';
import styles from './NotificationCard.module.scss';
import colors from '../../../../scss/colors';
import { ApproverCard } from './ApproverCard';
import { distanceDateFormat, sortArrayOfObjectsByDate } from '../../../../utils/helpers';
import { updateNotificationStatus } from '../../../../actions/appNotifications';

const NotificationList = ({ tneList, jobsList }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = useId();
  const [cardToggle, setCardToggle] = useState(true);
  const [approverRowData, setApproverRowData] = useState('');
  const [labelText, setLabelText] = useState('');

  const handleTneNotification = (e, rowData) => {
    e.stopPropagation();
    dispatch(updateNotificationStatus(rowData.Id, 'tne'));
    setApproverRowData(rowData);
    setCardToggle(!cardToggle);
    if (rowData.Status === notificationStatuses(t).draft.apiStatus) {
      setLabelText(t('dashboard.cards.newapprovercreated'));
    } else {
      setLabelText(t('dashboard.cards.newapproveradded'));
    }
  };

  const handleJobsNotification = (e, rowData) => {
    e.stopPropagation();
    const { JobAlert, Id } = rowData;
    dispatch(updateNotificationStatus(Id, 'JobAlert'));
    navigate(
      `/dashboard/Jobs?page=1&tab=publicjobs&subTab=saved&date=100&` +
        `${JobAlert.Keyword ? `searchTxt=${JobAlert.Keyword}` : ''}` +
        `${JobAlert.Location ? `&location=${JobAlert.Location}` : ''}` +
        `${JobAlert.City ? `&city=${JobAlert.City}` : ''}` +
        `${JobAlert.Country ? `&country=${JobAlert.Country}` : ''}` +
        `${JobAlert.RemoteWork === 2 ? `&remoteTypes=0&remoteTypes=1` : ''}` +
        `${JobAlert.RemoteWork === 1 ? `&remoteTypes=1` : ''}` +
        `${JobAlert.RemoteWork === 0 ? `&remoteTypes=0` : ''}`
    );
  };

  const renderJobs = (row) => {
    return (
      <TableRow key={row.Id}>
        <TableCell sx={{ p: 1, cursor: 'pointer' }} align="left" onClick={(e) => handleJobsNotification(e, row)}>
          <h5 className={!row.Read ? styles.activeAlert : styles.inActiveAlert} role="presentation">
            {row.JobAlert.Keyword}: {row.MatchingCount}
            {row.MatchingCount > 1 ? t('dashboard.cards.opportunities') : t('dashboard.cards.opportunity')}
            {(row.JobAlert.Location || (row.JobAlert.City && row.JobAlert.Country)) && t('dashboard.cards.in')} {` `}
            {!row.JobAlert.Location && !row.JobAlert.City && !row.JobAlert.Country && ', everywhere'}
            {row.JobAlert.Location ? row.JobAlert.Location : ''}
            {row.JobAlert.City ? row.JobAlert.City : ''} {row.JobAlert.Country ? row.JobAlert.Country : ''}
          </h5>
        </TableCell>
        <TableCell align="right" sx={{ color: colors.MEDIUM_GREY }}>
          <p className={styles.jobAlertTime}>{distanceDateFormat(row.CreatedDate)}</p>
        </TableCell>
      </TableRow>
    );
  };

  const renderTnE = (row) => {
    return (
      <TableRow key={row.Id} className={styles.tableRow}>
        <TableCell sx={{ p: 1 }} align="left" onClick={(e) => handleTneNotification(e, row)}>
          <h5 className={!row.Read ? styles.activeAlert : styles.inActiveAlert}>
            {row.Status === notificationStatuses(t).draft.apiStatus
              ? t('dashboard.cards.newapprovercreated')
              : t('dashboard.cards.newapproveradded')}
          </h5>
        </TableCell>
        <TableCell align="right" sx={{ color: colors.MEDIUM_GREY }}>
          <p>{distanceDateFormat(row.CreatedDate)}</p>
        </TableCell>
      </TableRow>
    );
  };

  const sortedJobsList = sortArrayOfObjectsByDate(jobsList || [], 'CreatedDate');
  const sortedTneList = sortArrayOfObjectsByDate(tneList || [], 'CreatedDate');

  return (
    <div className={`${styles.flipCardContainer} ${cardToggle ? styles.flipped : ''}`}>
      {cardToggle ? (
        <div className={`${styles.flipCard} ${styles.flipCardFront}`}>
          {sortedTneList?.length || sortedJobsList?.length ? (
            <div key={id} className={styles.cardList}>
              <Table size="small" aria-label="a dense table">
                <TableBody className={styles.jobsTableRows}>
                  {sortedJobsList?.map((item) => renderJobs(item))}
                </TableBody>
                <TableBody className={styles.tneTableRows}>{sortedTneList?.map((item) => renderTnE(item))}</TableBody>
              </Table>
            </div>
          ) : (
            <h5 key={id}>{t('dashboard.cards.nonewnotification')}</h5>
          )}
        </div>
      ) : (
        <div className={`${styles.flipCard} ${styles.flipCardBack}`}>
          <ApproverCard setCardToggle={setCardToggle} approverRowData={approverRowData} labelText={labelText} />
        </div>
      )}
    </div>
  );
};

export default NotificationList;
